export const INITIAL_CONTEXT_MODEL_STATE = {
    project: {
        address: {
            countryCode: 'DE'
        },
        building: {
            numberOfPersons: 3,
            standardTypeOfSunProtection: 'INTERNAL_BLINDS_DARK',
            standardTypeOfWindow: 'INSULATING_GLAZING_PLASTIC',
            buildingLevelHeight: 2.7,
            rooms: {
                'room-1': {
                    id: 'room-1',
                    name: 'BEDROOM LVL 1',
                    type: 'BEDROOM',
                    levelIds: ['lvl-1'],
                    height: 2.5,
                    isHeated: true,
                    isCooled: false,
                    residents: [
                        {
                            connectedLoad: 0.08,
                            amount: 1,
                            type: 'HUMAN_ADULT'
                        },
                        {
                            connectedLoad: 0.04,
                            amount: 2,
                            type: 'HUMAN_CHILD_PRESCHOOL'
                        }
                    ],
                    slabIds: ['t7TmoNB0cFvC', 'PjyjhJvKrCGs'],
                    wallIds: ['ckYqK0kz8Wnl', 'oIyqoGW0WOak', 'E6uMGjdONJoQ'],
                    heatSources: [
                        {
                            type: 'DEVICE_DISHWASHER',
                            connectedLoad: 200,
                            amount: 1
                        },
                        {
                            type: 'DEVICE_LAPTOP_DOCK',
                            connectedLoad: 100,
                            amount: 2
                        }
                    ]
                },
                'room-2': {
                    id: 'room-2',
                    name: 'BEDROOM LVL 2',
                    type: 'BEDROOM',
                    levelIds: ['lvl-2']
                },
                'room-3': {
                    id: 'room-3',
                    name: 'OFFICE_ROOM',
                    type: 'OFFICE_ROOM',
                    levelIds: ['lvl-2']
                },
                'room-4': {
                    id: 'room-4',
                    name: 'OFFICE_ROOM',
                    type: 'OFFICE_ROOM',
                    levelIds: ['lvl-1']
                }
            },
            levels: {
                'lvl-2': {
                    id: 'lvl-2',
                    name: '1st Level',
                    number: 1
                },
                'lvl-1': {
                    id: 'lvl-1',
                    name: 'Ground',
                    number: 0
                }
            },
            slabs: {
                t7TmoNB0cFvC: {
                    id: 't7TmoNB0cFvC',
                    zones: [
                        {
                            area: 20,
                            adjacentTo: {
                                type: 'GROUND'
                            }
                        }
                    ]
                },
                PjyjhJvKrCGs: {
                    zones: [
                        {
                            area: 20,
                            adjacentTo: {
                                type: 'ROOF'
                            }
                        }
                    ],
                    id: 'PjyjhJvKrCGs'
                }
            },
            walls: {
                ckYqK0kz8Wnl: {
                    id: 'ckYqK0kz8Wnl',
                    zones: [
                        {
                            area: 40,
                            adjacentTo: {
                                type: 'EXTERNAL'
                            }
                        }
                    ],
                    orientation: 'NORTH',
                    windowIds: ['YxFoz8jgp0Bf']
                },
                oIyqoGW0WOak: {
                    zones: [
                        {
                            area: 40,
                            adjacentTo: {
                                type: 'EXTERNAL'
                            }
                        }
                    ],
                    id: 'oIyqoGW0WOak',
                    orientation: 'EAST',
                    windowIds: ['Jr2N6yLuRHmo']
                },
                E6uMGjdONJoQ: {
                    zones: [
                        {
                            area: 30,
                            adjacentTo: {
                                type: 'UNHEATED_ROOM'
                            }
                        }
                    ],
                    id: 'E6uMGjdONJoQ',
                    orientation: 'SOUTH'
                }
            },
            windows: {
                YxFoz8jgp0Bf: {
                    id: 'YxFoz8jgp0Bf',
                    area: 2,
                    type: 'SINGLE_GLAZING',
                    typeOfSunProtection: 'AWNING'
                },
                Jr2N6yLuRHmo: {
                    area: 2,
                    id: 'Jr2N6yLuRHmo',
                    type: 'INSULATING_GLAZING_PLASTIC',
                    typeOfSunProtection: 'AWNING'
                }
            }
        }
    },
    variables: {},
    globals: {},
    inputs: {
        selectedRoomId: 'room-1'
    }
};
